import Vue from 'vue';

Vue.filter('formatPrice',function (val) {
  return val / 100
})

//将手机号格式转成 123****1234的格式
Vue.filter('hidePhone', function(val) {
  const head = val.slice(0,3);
  const foot = val.slice(-4)
  return `${head}****${foot}`
})